module.exports = __webpack_public_path__ + "img/diapositiva-2-3.583dbed6.png";